import React, { useState, useEffect } from "react";
import { removeFavorite, getFavoriteProviders } from "../APIs/favoriteApi";
import { getProvider } from "../APIs/providerApi.js";

const initialFavorites = [];

/*export default function FavoritesTab({patientId}) {
  const [favorites, setFavorites] = useState(initialFavorites);
  //const patientId = 1; // 🔹 replace with logged-in patientId

  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        // Step 1: get favorite records (with providerId)
        const favoritesData = await getFavoriteProviders(patientId);

        // Step 2: fetch provider details in parallel
        const detailedFavorites = await Promise.all(
          favoritesData.map(async (fav) => {
            try {
              const provider = await getProvider(fav.providerId);

              return {
                id: fav.providerId,
                name: `${provider.firstName} ${provider.lastName}`,
                email: provider.email,
                specialty: provider.specialties?.map((s) => s.name).join(', ') || 'N/A',
                facility: provider.facilityInformation?.map((f) => f.facilityName).join(', ') || 'N/A',
                location:
                  provider.facilityInformation
                    ?.map((f) => `${f.city}, ${f.state}`)
                    .join(', ') || 'N/A',
              };
            } catch (err) {
              console.error('Error fetching provider details:', err);
              return {
                id: fav.providerId,
                name: `${fav.firstName} ${fav.lastName}`,
                email: fav.email,
                specialty: 'Unknown',
                facility: 'Unknown',
                location: 'Unknown',
              };
            }
          })
        );

        setFavorites(detailedFavorites);
      } catch (error) {
        console.error('Error fetching favorites:', error);
      }
    };

    fetchFavorites();
  }, [patientId]);

  const unfavoriteProvider = async (providerId) => {
    try {
      await removeFavorite(patientId, providerId);
      setFavorites((prev) => prev.filter((provider) => provider.id !== providerId));
    } catch (error) {
      console.error('Error removing favorite:', error);
    }
  };*/

//const initialFavorites = [];

export default function FavoritesTab({ patientId }) {
  const [favorites, setFavorites] = useState(initialFavorites);

  useEffect(() => {
    const fetchFavorites = async () => {
      try {
        // Step 1: get favorite records (providerId + basic info)
        const favoritesData = await getFavoriteProviders(); // ⬅️ no patientId

        // Step 2: fetch provider details in parallel
        const detailedFavorites = await Promise.all(
          favoritesData.map(async (fav) => {
            try {
              const provider = await getProvider(fav.providerId);

              return {
                id: fav.providerId,
                name: `${provider.firstName} ${provider.lastName}`,
                email: provider.email,
                specialty:
                  provider.specialties?.map((s) => s.name).join(", ") || "N/A",
                facility:
                  provider.facilityInformation
                    ?.map((f) => f.facilityName)
                    .join(", ") || "N/A",
                location:
                  provider.facilityInformation
                    ?.map((f) => `${f.city}, ${f.state}`)
                    .join(", ") || "N/A",
              };
            } catch (err) {
              console.error("Error fetching provider details:", err);
              return {
                id: fav.providerId,
                name: `${fav.firstName} ${fav.lastName}`,
                email: fav.email,
                specialty: "Unknown",
                facility: "Unknown",
                location: "Unknown",
              };
            }
          }),
        );

        setFavorites(detailedFavorites);
      } catch (error) {
        console.error("Error fetching favorites:", error);
      }
    };

    fetchFavorites();
  }, [patientId]); // you can keep this if patientId drives when tab loads

  const unfavoriteProvider = async (providerId) => {
    try {
      await removeFavorite(providerId); // ⬅️ no patientId
      setFavorites((prev) =>
        prev.filter((provider) => provider.id !== providerId),
      );
    } catch (error) {
      console.error("Error removing favorite:", error);
    }
  };

  return (
    <div>
      <h3 className="text-xl font-semibold mb-4">Favorite Providers</h3>

      {favorites.length === 0 ? (
        <p className="text-gray-500">You have no favorite providers yet.</p>
      ) : (
        <div className="grid grid-cols-1 gap-4">
          {favorites.map((provider) => (
            <div
              key={provider.id}
              className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm"
            >
              <div className="flex justify-between items-start">
                <div>
                  <h4 className="text-lg font-bold text-gray-800">
                    {provider.name}
                  </h4>
                  <p className="text-sm text-gray-600">
                    <strong>Specialty:</strong> {provider.specialty}
                  </p>
                  <p className="text-sm text-gray-600">
                    <strong>Facility:</strong> {provider.facility}
                  </p>
                  <p className="text-sm text-gray-600">
                    <strong>Location:</strong> {provider.location}
                  </p>
                  <p className="text-sm text-gray-700">
                    <strong>Email:</strong> {provider.email}
                  </p>
                </div>
              </div>

              <div className="mt-4 flex flex-wrap gap-2">
                <button className="bg-blue-600 text-white text-sm px-4 py-1 rounded hover:bg-blue-700">
                  Book Appointment
                </button>
                <button
                  onClick={() => unfavoriteProvider(provider.id)}
                  className="text-sm text-red-600 hover:underline"
                >
                  🗑 Remove
                </button>
                <button className="text-sm text-green-600 hover:underline">
                  📧 Contact
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
